import React from "react";
import Link from "next/link";
import styles from "./TrustMarkerBadge.module.scss";
import { getTrustMarkerStyleClass } from "@configs/trustMarkerStyleConfig";
import { getTrustMarkerCollectionUrl } from "@helpers/trustMarkerSlugHelper";

export interface TrustMarkerBadgeProps {
  label: string;
  className?: string;
}

const TrustMarkerBadge: React.FC<TrustMarkerBadgeProps> = ({
  label,
  className = "",
}) => {
  const styleClass = getTrustMarkerStyleClass(label);
  const collectionUrl = getTrustMarkerCollectionUrl(label);

  return (
    <Link 
      href={collectionUrl}
      className={`${styles.trustMarkerBadge} ${styles[styleClass]} ${className}`}
    >
      <span className={styles.label}>{label}</span>
    </Link>
  );
};

export default TrustMarkerBadge;

